import { connect } from "react-redux";

import { FullFormState } from "../../../../../Engine/Core/Store/FullFormState";

import { AddressModal } from "./AddressModal";

const mapStateToProps = (state: FullFormState) => ({
    baseUrl: state.settings.keformsUrl,
});

export const AddressModalContainer = connect(mapStateToProps)(AddressModal);
